<template>
    <div class="layoutBasic weflix-admin-layoutBasic">
      <TitlePage title="Informações Básicas" subtitle="Personalize seu site com suas informações" hasMargin="false" />
        <div class="col-form-inner col-6 col-md-6 col-lg-6" v-if="hasReady">
           
            <!-- Nome Fantasia -->
            <div class="col-form-inner col-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <div class="form-label">
                    <label>Título do Site<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="name"
                      placeholder="Título do seu site"
                    />
                    <small class="alertText" v-if="error[0]">Campo obrigatório e deve ser preenchido corretamente.</small>
                  </div>
                </div>
            </div>
            <!-- Descrição -->
            <div class="col-form-inner col-12 col-md-12 col-lg-12 textarea">
                <div class="form-group">
                  <div class="form-label">
                    <label>Descrição<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input"> 
                    <textarea v-model="description"></textarea>
                    <small class="alertText" v-if="error[1]">Campo obrigatório e deve ser preenchido corretamente.</small>
                  </div>
                </div>
            </div>
            <!-- <hr/> -->
            <!-- <div class="col-form-inner col-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <div class="form-label">
                    <label>Título Sobre<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="comercialName"
                      placeholder="Sua empresa"
                    />
                    <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small>
                    <small>Nome comercial do seu curso, uso externo.</small>
                  </div>
                </div>
            </div> -->
            <!-- Descrição -->
            <div class="col-form-inner col-12 col-md-12 col-lg-12 textarea">
                <div class="form-group">
                  <div class="form-label">
                    <label>Descrição Sobre<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input"> 
                    <textarea v-model="descriptionAbout"></textarea>
                  </div>
                </div>
            </div>
            <div class="form-group-container" style="margin-top: 15px!important;">
              <v-select
                v-model="contentWarning"
                :items="contentWarningOptions"
                item-title="text"
                item-value="value"
                label="Aviso de Conteúdo Sensível"
                variant="outlined"
                class="filter-form-control"
                density="compact"
                hide-details
                style="min-width: 160px;"
              />
              <small class="text-muted">Exibir aviso de conteúdo sensível no site</small>
            </div>
        </div>
        <div class="col-form-inner col-6 col-md-6 col-lg-6" v-if="hasReady">
            <div class="col-form-inner col-12 col-md-12 col-lg-12 logo-form-inner">
                <div class="form-group">
                  <div class="form-label">
                    <label>Logo</label>
                    <small>Insira uma imagem maior que 120x60 pixels</small>
                  </div>
                  <div class="form-file">
                    <div class="file-wrapper primary">
                      <img
                      :src="logoPreview? logoPreview : logo"
                      alt="Logo"
                      v-show="logoPreview || logo"
                      style="width: auto;height: 120px;margin: 10px 0px;"

                    />
                      <span class="thumbnail" v-if="!logoPreview && !logo">
                        <span class="icon" v-if="loaderImage">
                          <svg
                            width="46"
                            height="39"
                            viewBox="0 0 46 39"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></path>
                            <rect
                              x="1.00049"
                              y="1.40454"
                              width="43.9461"
                              height="36.1909"
                              rx="2.58507"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></rect>
                            <circle
                              cx="14.8948"
                              cy="10.6676"
                              r="3.71629"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></circle>
                          </svg>
                        </span>
                        <span class="text" v-if="loaderImage">
                          Clique aqui para selecionar a imagem
                        </span>
                        <LoaderImage :hasReady="loaderImage"/>
                      </span>
                      <input
                        class="form-control"
                        type="file"
                        @change="updateFilePathLogo"
                        accept=".png, .jpg, .jpeg, .webp"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <div class="form-label">
                    <label>Favicon</label>
                    <small>Você pode adicionar uma imagem para ser o favicon do seu site.</small>

                  </div>
                  <div class="form-file">
                    <div class="file-wrapper primary">
                      <img
                        :src="faviconPreview ? faviconPreview : favicon "
                        alt="Logo"
                        v-show="faviconPreview || favicon"
                        style="width: 50px;margin: 10px 0px;"
                      />
                      <span
                        class="thumbnail"
                        v-if="!faviconPreview && !favicon"
                      >
                        <span class="icon" v-if="loaderImage">
                          <svg
                            width="46"
                            height="39"
                            viewBox="0 0 46 39"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></path>
                            <rect
                              x="1.00049"
                              y="1.40454"
                              width="43.9461"
                              height="36.1909"
                              rx="2.58507"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></rect>
                            <circle
                              cx="14.8948"
                              cy="10.6676"
                              r="3.71629"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></circle>
                          </svg>
                        </span>
                        <span class="text" v-if="loaderImage">
                          Clique aqui para selecionar a imagem
                        </span>
                        <LoaderImage :hasReady="loaderImage"/>
                      </span>
                     
                      <input
                        class="form-control"
                        type="file"
                        @change="updateFilePathFavicon"
                       
                      />
                    </div>
                  </div>
                </div>
              </div>
        </div>
        <div class="actionsSave" id="layoutBasicWeflix">
          <v-btn variant="outlined" border="2" color="primary" size="large" width="140" @click="updateWebsite" :disabled="!loaderImage" :class="{'disabled': !loaderImage}">Salvar</v-btn>
        </div>
    </div>
  <Loader :hasReady="hasReady" />
</template>
<script>
import websiteApi from '@/utils/Weflix/website';
import apiAWS from '@/utils/storage/aws';
import { mapState, mapActions } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import LoaderImage from '@/components/Weflix/LoaderImage';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';
import companyApi from '@/utils/Weflix/company';

export default {
  data() {
    return {
      description: '',
      logo: '',
      favicon: '',
      logoPreview: '',
      faviconPreview: '',
      id: '',
      error: [false, false],
      hasReady: false,
      facebook: '',
      gads: '',
      ganalytic: '',
      tagManager: '',
      rdrefreshToken: '',
      rdcode: '',
      rdSecret: '',
      rdClient: '',
      color: '',
      activeTheme: null,
      descriptionAbout: '',
      facebook: '',
      gads: '',
      ganalytic: '',
      tagManager: '',
      rdrefreshToken: '',
      rdcode: '',
      rdSecret: '',
      rdClient: '',
      loaderImage: true,
      logoChanged: false,      // <--- flag para saber se o logo foi alterado localmente
      faviconChanged: false,   // <--- flag para saber se o favicon foi alterado localmente
      contentWarning: '',
      contentWarningOptions: [
        { text: 'Selecione uma opção', value: '' },
        { text: 'Sim', value: '1' },
        { text: 'Não', value: '0' }
      ],
      infoCompany: {}
    };
    },
    computed: {
        ...mapState(['token', 'layoutWebsite'])
    },
    components: {
        Loader,
        LoaderImage,
        TitlePage
    },
    methods: {
      ...mapActions(['storeLayoutWebsite']),
        async getWebsite() {
            const response = await websiteApi.getWebsite(this.token);
            this.storeLayoutWebsite({ layoutWebsite: response });

            // Atribuindo todos os campos retornados pela API
            this.id = this.layoutWebsite.id;
            this.name = this.layoutWebsite.nome;
            this.title = this.layoutWebsite.title;
            this.url = this.layoutWebsite.url;
            this.url1 = this.layoutWebsite.url1;
            this.url2 = this.layoutWebsite.url2;
            this.description = this.layoutWebsite.description;
            this.keywords = this.layoutWebsite.keywords;
            this.logo = this.layoutWebsite.logo;
            this.logoPreview = this.layoutWebsite.logoFinal;
            this.favicon = this.layoutWebsite.favicon;
            this.faviconPreview = this.layoutWebsite.faviconFinal;
            this.color = this.layoutWebsite.color;
            this.status = this.layoutWebsite.status;
            this.tagManager = this.layoutWebsite.tagManagerCode;
            this.activeTheme = this.layoutWebsite.typeLayout;
            this.javascript = this.layoutWebsite.javascript;
            this.css = this.layoutWebsite.css;
            this.typeLayoutPortal = this.layoutWebsite.typeLayoutPortal;
            this.ganalytic = this.layoutWebsite.googleAnalyticsCode;
            this.gads = this.layoutWebsite.googleAdsCode;
            this.facebook = this.layoutWebsite.facebookPixelCode;
            this.dateInsert = this.layoutWebsite.dateInsert;
            this.email = this.layoutWebsite.email;
            this.phone = this.layoutWebsite.phone;
            this.numberCollection = this.layoutWebsite.numberCollection;
            this.numberVideo = this.layoutWebsite.numberVideo;
            this.timeVideo = this.layoutWebsite.timeVideo;
            this.numberSubscription = this.layoutWebsite.numberSubscription;
            this.descriptionAbout = this.layoutWebsite.about;
            this.termUse = this.layoutWebsite.termUse;
            this.typeImageCoverCourse = this.layoutWebsite.typeImageCoverCourse;
            this.visibleTitleCourse = this.layoutWebsite.visibleTitleCourse;
            this.rdSecret = this.layoutWebsite.rdsecretClient;
            this.rdClient = this.layoutWebsite.rdclienteId;
            this.rdcode = this.layoutWebsite.rdcode;
            this.rdrefreshToken = this.layoutWebsite.rdrefreshToken;

            // Resetar flags de alteração de logo/favicon ao carregar do servidor
            this.logoChanged = false;
            this.faviconChanged = false;

            this.hasReady = true;
        },
        async getInfoCompany() {
      try {
        const response = await companyApi.getCompany(this.token);
        this.infoCompany = response;
        this.contentWarning = response.ageRestricted !== undefined && response.ageRestricted !== null ? String(response.ageRestricted) : '';
      } catch (error) {
        toast.error('Erro ao obter dados da empresa');
      }
    },
    async setInfoCompany() {
      try {
        const payload = {
          ...this.infoCompany,
          ageRestricted: this.contentWarning !== '' ? parseInt(this.contentWarning) : null
        };
        const response = await companyApi.editCompany(this.token, payload);
      
        toast.success('Dados da empresa salvos com sucesso!');
      } catch (error) {
        toast.error('Erro ao salvar dados da empresa');
        console.error('Erro ao salvar dados da empresa:', error);
      }
    },
        async updateWebsite() {
            if (this.verifyFields()) {
                this.hasReady = false;

                // Garante que, se o usuário não fez upload local, o valor enviado é o do servidor
                // Se fez upload local, o valor já está atualizado nos campos logo/logoPreview e favicon/faviconPreview
                const payload = {
                    "nome": this.name,
                    "title": this.title,
                    "url": this.url,
                    "url1": this.url1,
                    "url2": this.url2,
                    "description": this.description,
                    "keywords": this.keywords,
                    "logo": this.logoChanged ? this.logo : this.layoutWebsite.logo, // sobrescreve só se mudou localmente
                    "logoFinal": this.logoChanged ? this.logoPreview : this.layoutWebsite.logoFinal,
                    "favicon": this.faviconChanged ? this.favicon : this.layoutWebsite.favicon,
                    "faviconFinal": this.faviconChanged ? this.faviconPreview : this.layoutWebsite.faviconFinal,
                    "color": this.color,
                    "status": this.status,
                    "tagManagerCode": this.tagManager,
                    "typeLayout": this.activeTheme,
                    "javascript": this.javascript,
                    "css": this.css,
                    "typeLayoutPortal": this.typeLayoutPortal,
                    "googleAnalyticsCode": this.ganalytic,
                    "googleAdsCode": this.gads,
                    "facebookPixelCode": this.facebook,
                    "dateInsert": this.dateInsert,
                    "email": this.email,
                    "phone": this.phone,
                    "numberCollection": this.numberCollection,
                    "numberVideo": this.numberVideo,
                    "timeVideo": this.timeVideo,
                    "numberSubscription": this.numberSubscription,
                    "about": this.descriptionAbout,
                    "termUse": this.termUse,
                    "typeImageCoverCourse": this.typeImageCoverCourse,
                    "visibleTitleCourse": this.visibleTitleCourse,
                    "rdsecretClient": this.rdSecret,
                    "rdclienteId": this.rdClient,
                    "rdcode": this.rdcode,
                    "rdrefreshToken": this.rdrefreshToken
                };
                try {
                  if (this.contentWarning !== '') {
                    await this.setInfoCompany();
                  }
                    const response = await websiteApi.editWebsite(this.token, this.id, payload);
                    this.getWebsite();
                    this.clearCache();
                    this.hasReady = true;
                    this.notify('Dados atualizados com sucesso!', 'success');
                } catch (error) {
                    this.notify('Erro ao atualizar dados do website.', 'error');
                    console.error('Erro ao atualizar dados do website:', error);
                }
            }
        },
        verifyFields() {
            if (!this.name) {
                this.error[0] = true; 
                return false;
            }
            if (!this.description) {
              this.error[1] = true;
              return false;
            }
            return true;
        },
        async clearCache(){
        try {
          const response = await websiteApi.clearCache(this.token);
          this.messageStatusCache = true;
        } catch (error) {
          console.error('Erro ao limpar cache', error);
        }
      },
        async putFileAws(url, file){
          try {
              const response = await apiAWS.putFileAWS(url, file);
          } catch (error) {
              console.error('Erro ao enviar arquivo para AWS');
          }
        },
        async updateFilePathLogo(event){
            this.loaderImage = false;
            const file = event.target.files[0];
            this.logoPreview = URL.createObjectURL(file);
            try {
                const response =  await apiAWS.getSignatureImage(this.token, file.name);
                this.putFileAws(response.url, file);
                this.logo = response.token;
                this.logoChanged = true; // Marca que o logo foi alterado localmente
                this.loaderImage = true;
            } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        async updateFilePathFavicon(event){
            this.loaderImage = false;
            const file = event.target.files[0];
            this.faviconPreview = URL.createObjectURL(file);
            try {
                const response =  await apiAWS.getSignatureImage(this.token, file.name);
                this.putFileAws(response.url, file);
                this.favicon = response.token;
                this.faviconChanged = true; // Marca que o favicon foi alterado localmente
                console.debug(response);
                this.loaderImage = true;
              } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
    },
    created() {
        this.getWebsite();
        this.getInfoCompany();
    }
  }
</script>

<style>
@import url('./css/basic.css');
</style>